import { app } from '../../app.module'
interface BrandCategory {
  brandCategoryName: string
  subCategoryName: string
  sortNo: number
}

/**
 * ブランドサブカテゴリフォーム
 * @class BrandSubCategoryFormCtrl
 */
class BrandSubCategoryFormCtrl {
  private type: string
  private brandCategories: BrandCategory[]
  private brandSubCategories: string[]
  private subCategory: string
  private getFromLocalFlg: boolean
  private saveToLocalFlg: boolean
  private includeEmptyOptionFlg: boolean
  private selectedCategory: {
    categoryName: string
    subCategoryName: string
  }

  constructor(
    $scope: ng.IScope,
    private $rootScope,
    private localStorageService
  ) {
    // カテゴリ一覧の取得イベント
    $scope.$on(
      'getAllBrandCategory',
      (
        event,
        data: {
          type: string
          brandCategories: BrandCategory[]
        }
      ) => {
        if (this.type === data.type) {
          this.brandCategories = data.brandCategories
          // ローカルストレージから選択したカテゴリを取得
          if (this.getFromLocalFlg && !this.subCategory) {
            this.getCategoryFromLocal()
            // カテゴリの変更
            this.subCategory = this.selectedCategory.subCategoryName
          }
        }
      }
    )
    // ブランドカテゴリ変更イベント
    $scope.$on('changeBrandCategory', this.onChangeCategory)
  }

  /**
   * 初期化イベント
   */
  public $onInit() {
    if (this.getFromLocalFlg !== false) {
      this.getFromLocalFlg = true
    }
    if (this.saveToLocalFlg !== false) {
      this.saveToLocalFlg = true
    }
    if (this.includeEmptyOptionFlg !== false) {
      this.includeEmptyOptionFlg = true
    }
    this.brandCategories = []
    this.brandSubCategories = []
    this.selectedCategory = {
      categoryName: null,
      subCategoryName: null,
    }
    if (!this.subCategory) {
      this.subCategory = null
    }
  }

  /**
   * サブカテゴリの変更
   */
  public changeSubCategory = () => {
    this.selectedCategory.subCategoryName = this.subCategory
    if (this.subCategory === '指定しない') {
      this.selectedCategory.subCategoryName = null
    }
    if (this.saveToLocalFlg) {
      // カテゴリをローカルストレージに保存する
      this.saveCategoryToLocal()
    }
    // ブランドサブカテゴリ変更イベントをbroadcastする
    this.$rootScope.$broadcast('changeFilterData', {
      subCategoryType: this.type,
      type: 'subCategoryFilter',
      value: this.selectedCategory.subCategoryName,
    })
  }

  /**
   * ブランドカテゴリ変更イベント
   * @param {{type: string, categoryName: string, subCategoryName: string}} data データ
   * @private
   */
  private onChangeCategory = (
    event,
    data: {
      type: string
      categoryName: string
      subCategoryName: string
    }
  ) => {
    if (this.type !== data.type) {
      return
    }
    this.subCategory = data.subCategoryName
    this.selectedCategory.categoryName = data.categoryName
    this.brandSubCategories = []
    const category = this.brandCategories.filter((category) => {
      return category.brandCategoryName === data.categoryName
    })[0]
    if (!category) {
      return
    }
    if (category.subCategoryName) {
      this.brandSubCategories = category.subCategoryName.split(',')
    }
    if (this.includeEmptyOptionFlg) {
      this.brandSubCategories.unshift('指定しない')
    }
  }

  /**
   * ローカルストレージから選択したカテゴリをセット
   * @private
   */
  private getCategoryFromLocal() {
    // 選択したカテゴリ
    const selectedCategory: {
      categoryName: string
      subCategoryName: string
    } = this.localStorageService.get('selectedCategory')

    // 選択したカテゴリがない場合は、リターン
    if (!selectedCategory) {
      this.selectedCategory = {
        categoryName: null,
        subCategoryName: null,
      }
      return
    }

    this.selectedCategory = selectedCategory

    const filterCategory = this.brandCategories.filter((category) => {
      return category.brandCategoryName === selectedCategory.categoryName
    })[0]

    // ローカルストレージに保存されているブランドカテゴリが存在しない場合
    if (!filterCategory) {
      this.selectedCategory = {
        categoryName: null,
        subCategoryName: null,
      }
      return
    }

    // // 選択したサブカテゴリがフィルターカテゴリのサブカテゴリ一覧に存在しない場合は、nullをセット
    if (
      selectedCategory.subCategoryName &&
      (filterCategory.subCategoryName === null ||
        filterCategory.subCategoryName.split(',').indexOf(selectedCategory.subCategoryName) === -1)
    ) {
      this.selectedCategory.subCategoryName = null
    }
  }

  /**
   * カテゴリをローカルストレージに保存する
   * @private
   */
  private saveCategoryToLocal() {
    this.localStorageService.set('selectedCategory', this.selectedCategory)
  }
}

/**
 * ブランドサブカテゴリフォームコンポーネント
 * attr: {string} type タイプ
 * attr: {string} subCategory サブカテゴリ
 * attr: {boolean} getFromLocalFlg ローカルストレージから選択したカテゴリをセット
 * attr: {boolean} saveToLocalFlg カテゴリ変更するとき、ローカルストレージに保存するフラグ
 * attr: {boolean} includeEmptyOptionFlg 指定しないを含むフラグ
 */
app.component('brandSubCategoryForm', {
  bindings: {
    type: '@',
    subCategory: '<',
    getFromLocalFlg: '<',
    saveToLocalFlg: '<',
    includeEmptyOptionFlg: '<',
  },
  template: require('./brand-sub-category-form.pug')(),
  controller: BrandSubCategoryFormCtrl,
})
